
import PersonIcon from '@mui/icons-material/Person';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';


const WorkForceMgmt = {
  id: '27',
  title: 'Work Force Mgmt',
  type: 'group',
  role: 'FACTORY_MANAGER,FACTORY_ADMIN',
  children: [
    {
      id: 'worker',
      title: 'Worker',
      type: 'item',
      bottomMenu:'WORKERS',
      url: '/',
      icon: PersonIcon
    },{
      id: 'product2skill2exp2rate',
      title: 'Rate Mgmt',
      type: 'item',
      url: '/',
      bottomMenu:'WORKER-RATE-MGMT',
      icon: CurrencyRupeeIcon
    },
    ,{
      id: 'sticthcingtaskList',
      title: 'Stitching Task',
      type: 'item',
      url: '/',
      bottomMenu:'STITCHING-TASK',
      icon: PlaylistAddCheckIcon
    },
  ]
};

export default WorkForceMgmt;